module.exports = __webpack_public_path__ + "img/SWP_Shield_09.51f532d5.png";